import api from "./api";

export const fetchPriorAuths = async (memberId) => {
  try {
    const response = await api.get(`/prior-auths/members/${memberId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching prior authorizations:", error);
    throw error;
  }
};